/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice\src\Content\Offers\OfferTableUser\OfferTableUser.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice
 * Created Date: Thursday July 4th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday, 25th September 2024 03:54:15
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { OfferUserType } from "Types/offer.type";
import { useEffect, useMemo, useState } from "react";
import OfferService from "Services/Offer/OfferService";
import { OfferRowUser } from "./OfferRowUserSingle/OfferRowUser";
import { TablePaper } from "Content/Table/TablePaper";
import Styles from "Content/OfferUser/OfferUser.module.css";
import translator from "MultiLanguage/TranslationWrapper";
import ServiceGeneral from "Services/ServiceGeneral";

export default function OfferTableUser(props: {buy?: boolean}) {
    const [offers, setOffers] = useState<OfferUserType[]>([]);

    useEffect(() => {
        ServiceGeneral.manageAxiosResponse(() => {if (props.buy){ return OfferService.getMyBoughtCars()} else{ return OfferService.getMyOffers() }}).then((result) => {
            setOffers(result.data);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const offerKeysOffer = ["", "Date", "Vehicle", "Value", "Status"];

    const buildRows = (offers: OfferUserType[]) => {
        const offerToDisplay = [];
        for (let i = 0; i < offers.length; ++i)
            offerToDisplay.push(<OfferRowUser key={Math.random()} Offer={offers[i]} />);
        return offerToDisplay;
    };

    const offerValues = useMemo(() => {
        return buildRows(offers);
    }, [offers]);

    return (
        <>
            {
                offers.length > 0 ?
                    <div className={`${Styles.tableOffer}`}>
                        <TablePaper items={offerValues} headerList={offerKeysOffer} />
                    </div>
                    :
                    <div className={`${Styles.altContent}`}>
                        <h2 className={`${Styles.message}`}>{translator.decode(`car.${props.buy ? "no_bought" : "no_offer"}`)}</h2>
                        <img loading="lazy" className={`${Styles.gif}`} src="/cart.gif" alt={translator.decode(`car.${props.buy ? "no_bought" : "no_offer"}`)} />
                    </div>
            }
        </>
    )
};
